import { extend, setInteractionMode } from 'vee-validate';
import { required, email, numeric, max } from 'vee-validate/dist/rules';

const veeValidateConfig = {
  created() {
    // VeeValidate v3 Documentation: https://vee-validate.logaretm.com/v3/overview.html

    // Set interaction mode: eager. Fields will validate on blur initially, then
    // on keyup when next edited
    setInteractionMode('eager');

    // VeeValidate v3 uses ValidationProvider, and imports each rule as needed
    // to save on bundle size

    // Initialize rules that we require in our app with custom messaging

    extend('required', {
      ...required,
      message: 'This field is required'
    });

    extend('email', {
      ...email,
      message: 'Please provide a valid email address'
    });

    extend('max', {
      ...max,
      message: 'You have exceeded the maximum character length'
    });

    extend('numeric', {
      ...numeric,
      message: 'Please enter numeric values only'
    });
  }
}

export default veeValidateConfig;



// WEBPACK FOOTER //
// ./src/mixins/veeValidateConfig.js